import { render } from "./NotFound.vue?vue&type=template&id=a5000c48"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
script.render = render

export default script